import React from 'react';
import { Layout } from '../components/Layout';
import { Card } from '../components/ui/Card';
import { Mail, MessageSquare } from 'lucide-react';
export function Contact() {
  return <Layout data-id="element-276">
      <div className="max-w-3xl mx-auto px-4 py-16 text-center" data-id="element-277">
        <h1 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-278">
          Centro de Soporte
        </h1>
        <p className="text-gray-500 mb-12" data-id="element-279">
          Estamos acá para ayudarte con tus acuerdos.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-280">
          <Card className="flex flex-col items-center text-center hover:border-gray-300 transition-colors cursor-pointer" data-id="element-281">
            <div className="w-12 h-12 bg-blue-50 rounded-full flex items-center justify-center mb-4" data-id="element-282">
              <Mail className="w-6 h-6 text-blue-600" data-id="element-283" />
            </div>
            <h3 className="font-bold text-gray-900 mb-2" data-id="element-284">Email</h3>
            <p className="text-sm text-gray-500" data-id="element-285">soporte@agreexa.com</p>
          </Card>

          <Card className="flex flex-col items-center text-center hover:border-gray-300 transition-colors cursor-pointer" data-id="element-286">
            <div className="w-12 h-12 bg-green-50 rounded-full flex items-center justify-center mb-4" data-id="element-287">
              <MessageSquare className="w-6 h-6 text-green-600" data-id="element-288" />
            </div>
            <h3 className="font-bold text-gray-900 mb-2" data-id="element-289">WhatsApp</h3>
            <p className="text-sm text-gray-500" data-id="element-290">Lunes a Viernes, 9 a 18hs</p>
          </Card>
        </div>
      </div>
    </Layout>;
}